import { useQuery, UseQueryResult } from 'react-query';

import { getTokenWithType } from './useAuth';

import { questionDetailItem as getQuestionDetail } from '../utils/urls';

import { AddEditQuestionType } from 'types/questions';
import { ErrorModal } from 'types/modalTypes';

async function fetchQuestionDetail({
  questionTemplateId,
}: TVariables): Promise<apiResult> {
  const response = await fetch(getQuestionDetail(questionTemplateId), {
    method: 'GET',
    headers: {
      Authorization: getTokenWithType(),
    },
  });
  return response.json();
}

type TError = ErrorModal;

type apiResult = {
  IsSuccess: boolean;
  StatusCode: number;
  Data: AddEditQuestionType | undefined;
};

type TResult = AddEditQuestionType | undefined;

type TVariables = {
  questionTemplateId: number;
};

function useGetQuestionDetail(
  questionTemplateId: number,
): UseQueryResult<TResult, TError> {
  return useQuery(
    ['get_question_detail', questionTemplateId],
    async () => {
      if (questionTemplateId) {
        const questionDetails = await fetchQuestionDetail({
          questionTemplateId,
        });
        return questionDetails.Data;
      }
    },
    {
      refetchOnWindowFocus: false,
    },
  );
}

export { useGetQuestionDetail };
